<template>
    <div class="_serviceCases">
        <ElasticList
            :list.sync="casesList"
            :filter="caseMapFilter"
            ref="casesListRef"
        />
    </div>
</template>

<script>
import _ from 'lodash';
import Record from '@/mixins/Record';
import { API, graphqlOperation } from "aws-amplify";
import * as queries_custom from '@/graphql/queries_custom';
import moment from 'moment';

export default {
    name: "ServiceCases",
    mixins: [Record],
    props: {
        routeParamsId: {
            type: String,
            required: true
        },
        caseListData: {
            type: Object,
            required: true
        },
        caseMapFilter: {
            type: Object,
            required: false
        },
    },
    data() {
        return {
            casesList: {
                hideTableToolbar: true,
                hideItemActions: true,
                hideRefreshIcon: true,
                hideListHeader: true,
                hideNewRecordButton: true,
                isToolbarHidden: true,
                refreshData: false,
                itemActions: [],
                editPath: "cases",
                linkRows: false,
                pageTitle: "Cases",
                pageIcon: "how_to_vote",
                listQueryId: this.caseListData.listQueryId,
                responseFieldName: this.caseListData.responseFieldName,
                listQueryTarget: this.caseListData.listQueryTarget,
                columns: {
                    'esData.case.subject': { label: "Subject", sortable: false, esNested: true },
                    'esData.case.createdAt': { label: "Created", sortable: false, esNested: true },
                    'esData.case.user': { label: "User", sortable: false, searchable: true, display: true, esNested: true, nested: ["given_name", "family_name"] },
                    'esData.case.status': { label: "Status", sortable: false,esNested: true  },
                    'esData.case.priority': { label: "Priority", sortable: false,esNested: true  },
                  'esData.case.template.subject': { label: "Type", sortable: false, searchable: true, display: true, esNested: true },
                  'esData.case.closedDate': { label: "Close Date", sortable: false,esNested: true  },
                },
                linkConfigs: [
                  {
                    name: 'subject',
                    hrefCallback: (column, name, item) => {
                      return '#/cases/' + item.id;
                    },
                    titleCallback: (column, name, item) => {
                      return item.subject;
                    },
                  }
                ],
                defaults: {
                    sort: 'createdAt',
                    sortDir: 'desc',
                    perPage: 5,
                },
                currentSort: "createdAt",
                currentSortOrder: "desc",
                pagination: {
                    perPage: 5,
                    currentPage: 1,
                    perPageOptions: [5, 10, 25, 50],
                    total: 0,
                },
                tableData: [],
                searchedData: [],
                fuseSearch: null,
              formatResponse: (data) => {
                let result = [];

                if (data && data[this.caseListData.listQueryTarget] && data[this.caseListData.listQueryTarget].items.length) {
                  this.$c.log('formatResponse data', data[this.caseListData.listQueryTarget].items);

                  data[this.caseListData.listQueryTarget].items.forEach((item) => {
                    item.relateRecordId = item.id;
                    item.id = item.case.id;

                    if (item.esData) {
                      let esData = JSON.parse(item.esData);
                      if (esData.case) {

                        if (!esData.case.team) {
                          esData.case.team = {
                            name: ''
                          };
                        }

                        if (!esData.case.template) {
                          esData.case.template = {
                            subject: ''
                          };
                        } else {
                          esData.case.template.subject = esData.case.template.subject.replace(/_/g, ' ');
                        }

                        esData.case.status = (esData.case.status) ? esData.case.status.replace(/_/g, ' ') : "";

                        //ATLAS-1175: <Service><Case tab> Add Closed Date in Hover Menu
                        if (esData.case.closedDate) {
                          let closedDate = moment(esData.case.closedDate).format('MM/DD/YYYY HH:mm:ss');
                          esData.case.closedDate = closedDate;
                        }

                      }
                      item.esData = JSON.stringify(esData);
                    }
                    result.push(item);
                  })
                }
                return result;
              },
                subscriptions: {
                    onCreateCase: {
                        result: null,
                        load: true,
                        function: (eventData) => {
                            this.$c.log('SUBSCRIPTION Trigger: onCreateCase');
                            this.$refs.casesListRef.refresh()
                        }
                    },
                    onUpdateCase: {
                        result: null,
                        load: true,
                        function: (eventData) => {
                            this.$c.log('SUBSCRIPTION Trigger: onUpdateCase');
                            this.$refs.casesListRef.refresh()
                        }
                    },
                    onDeleteCase: {
                        result: null,
                        load: true,
                        function: (eventData) => {
                            this.$c.log('SUBSCRIPTION Trigger: onDeleteCase');
                            this.$refs.casesListRef.refresh()
                        }
                    },
                    onCreateCaseService: {
                        result: null,
                        load: true,
                        function: (eventData) => {
                            this.$c.log('SUBSCRIPTION Trigger: onCreateCaseService');
                            this.$refs.casesListRef.refresh()
                        }
                    },
                    onUpdateCaseService: {
                        result: null,
                        load: true,
                        function: (eventData) => {
                            this.$c.log('SUBSCRIPTION Trigger: onUpdateCaseService');
                            this.$refs.casesListRef.refresh()
                        }
                    },
                    onDeleteCaseService: {
                        result: null,
                        load: true,
                        function: (eventData) => {
                            this.$c.log('SUBSCRIPTION Trigger: onDeleteCaseService');
                            this.$refs.casesListRef.refresh()
                        }
                    },
                },
            },
        };
    },
};
</script>

<style lang="scss">
#app .md-button.md-tab-nav-button[href*="cases"] {
    overflow: visible !important;

    &:hover ._serviceCases {
        opacity: 1;
        visibility: visible;
    }
}
#app ._serviceCases {
    opacity: 0;
    visibility: hidden;
    position: absolute;
    top: 100%;
    left: 0;
    width: 760px;
    padding: 0;
    margin: 0;

    &::before {
        content: '';
        position: absolute;
        bottom: 100%;
        left: 45px;
        border: 8px solid transparent;
        border-bottom-color: #745b8a;
    }

    .md-card {
        margin: 0;
    }

    .md-card-header {
        padding: 0;
    }

    .md-card-content {
        padding: 0;
    }

    .list-header-hidden {
        display: none;
    }

    .md-table {
        margin: 0;
    }

    .md-table-row {
        background-color: #fff;
        cursor: default !important;
        &:hover {
            background-color: #f9f9f9;
        }
    }

    .md-table-head {
        background-color: #745b8a;
    }

    .md-table-head-container,
    .md-table-head-label {
        height: auto;
        background-color: inherit;
        color: inherit;
        text-align: left;
        transition: none;
    }

    .md-table-head-label {
        padding: 8px 10px 5px;
        color: #fff;
        cursor: default;
        font-size: 12px;
        font-weight: 500;
        line-height: inherit;
        text-transform: none;
    }

    .md-ripple {
        display: block;
        padding: 0;
        cursor: default;
    }

    .md-card-actions {
        display: none;
    }

    .md-table-cell {
        height: auto;
        width: auto;
        padding: 10px !important;
        border-bottom-color: #e5e5e5;
    }

    .md-table-cell-container {
        justify-content: flex-start;
        font-size: 12px;
        font-weight: normal;
        line-height: 1.35;
        text-align: left !important;
        text-transform: none;
        white-space: normal;
        word-break: break-all;

        a,
        &:hover {
            background-color: transparent;
        }
    }
}
</style>
